import styled, { css } from 'styled-components'

import { colors } from '../../styles/colors'
import { ITitleProps } from './PageComponent.types'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;

  flex-direction: column;
  align-items: center;

  background: ${colors.blue};
`

export const Logo = styled.img`
  width: 160px;
  margin-bottom: 60px;
`

export const Icon = styled.img`
  width: 150px;
  margin-bottom: 60px;
`

export const Title = styled.span<ITitleProps>`
  font-weight: 700;
  font-size: 1.75rem;

  text-align: center;

  color: ${colors.white};

  line-height: 32px;

  ${props =>
    !props.haveIcon &&
    css`
      margin: 50px;
    `}
`

export const ContainerHeader = styled.div`
  display: flex;

  flex-direction: column;

  align-items: center;
  margin-bottom: 60px;
`

export const ContainerBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  padding-left: 40px;
`

export const ButtonGoBackStep = styled.button`
  border: none;
  background: transparent;
`
